import { graphql } from 'gatsby';
import React, { useEffect, useState } from 'react';
import Seo from 'gatsby-plugin-wpgraphql-seo';
import Layout from '~/components/Layout';
import HeroResources from '~/components/organisms/HeroResources';
import FeaturedResources from '~/components/organisms/FeaturedResources';
import ResourcesSlider from '~/components/organisms/ResourcesSlider';
import CustomSEO from '~/components/seo/CustomSEO';
import ResourcesParis from '~/components/organisms/ResourcesParis';
import globalState from '~/store';


const ResourcesParisPage = (props) => {

  // ⬅️ Hardcode the page’s logical resource type
  const resourceType = 'partner';

  const {
    data: {
      wpPage: {
        title,
        resourcesListing: { resourcesListing },
        pageLanguage = 'fr'
      },
      allWpPost,
      wp,
    },
  } = props;

  const [type, setType] = globalState('resourceType');
  useEffect(() => {
    setType(resourceType);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // OP-1375 => S47 – schema override (guarded)
  const [modifiedPostSchema, setModifiedPostSchema] = useState(null);
  useEffect(() => {
    const raw = wp?.seo?.contentTypes?.post?.schema?.raw;
    if (raw) {
      try {
        const schemaData = JSON.parse(raw);
        const lastItem = schemaData?.['@graph']?.[2]?.itemListElement?.slice(-1)?.[0];
        if (lastItem && !lastItem.name) {
          lastItem.name = title;
          setModifiedPostSchema(JSON.stringify(schemaData));
        }
      } catch {/* noop */ }
    }
  }, [title, wp]);

  const firstPost = allWpPost?.nodes?.[0];

  return (
    <Layout showResourcesNav={false} headerBgWhite pageLanguage="fr">
      <Seo title={`${title} | City Relay`} postSchema={modifiedPostSchema ? JSON.parse(modifiedPostSchema) : null} />
      <CustomSEO seo={wp?.seo} />

      {firstPost && resourcesListing?.heading && (
        <HeroResources heading={resourcesListing.heading} post={firstPost}  pageLanguage="fr" />
      )}

      {resourcesListing?.categories?.map(({ type, header, category }, i) =>
        type !== 'slider' ? (
          <FeaturedResources key={`${type}-${i}`} heading={header?.heading} button={header?.button} type={type} category={category} pageLanguage="fr"/>
        ) : (
          <ResourcesSlider
            key={`${type}-${i}`}
            title={header?.heading || category?.name}
            button={[header?.button]}
            posts={category?.posts?.nodes || []}
          />
        )
      )}
      {/* List section: your hook reads this prop */}
      <ResourcesParis resourceType={resourceType} />
    </Layout>
  );
};

export default ResourcesParisPage;

// 🔧 Hardcode "partner" in the query too (don’t use $resourceType here)
export const pageQuery = graphql`
  query ResourcesParisTemplate($id: String!) {
    allWpPost(
      limit: 1
      sort: { fields: date, order: DESC }
      filter: {
        resourceTypes: { nodes: { elemMatch: { slug: { eq: "partner" }}}}
           resourcePostItem: { resourcePostItem: { category: {eq: "paris"  } } }
        categories: { nodes: { elemMatch: { name: { nin: ["Uncategorized", "Uncategorised"] }}}}
      }
    ) {
      nodes {
        ...PostPreview
        id
        slug
        resourcePostItem { resourcePostItem { city: category } }
      }
    }

    wpPage(id: { eq: $id }) {
      title
      resourcesListing {
        resourcesListing {
          heading
          categories {
            type
            header { heading button { ...Button } }
            category {
              name
              posts {
                nodes {
                  ...PostPreview
                  id
                  slug
                  resourcePostItem { resourcePostItem { city: category } }
                }
              }
            }
          }
        }
      }
    }

    wp {
      seo {
        contentTypes { post { schema { raw } } }
      }
    }
  }
`;
